import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { title } from "process";

@Component({
    selector: "web-pan-expired",
    templateUrl: "./pan-expired.component.html",
    styleUrls: ["./pan-expired.component.scss"],
})
export class PanExpiredComponent {
    stage: string = "UPLOAD_PAN_CARD";

    constructor(private router: Router) {}

    ngOnInit() {
        this.stage = history.state?.stage || this.stage;
    }

    uploadPan() {
        this.router.navigate(["/loan/kyc/pan-kyc"], { state: { title: "Enter your PAN" } });
    }
}
